import { WalletsInfo } from './walletsInfo';
import { OperationsHistory } from './operationsHistory';

export const BalancePage = () => {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-6">
        <h1 className="text-2xl font-semibold">Мой баланс</h1>

        <WalletsInfo
          balance={280000}
          wallets={[
            {
              application: { name: 'АБВ-123456-789', id: '1' },
              expiredData: '2026-10-12',
              walletAddress: 'EJgH1Cey379sTCe2WDYsois3nm9z5dMUwtGY8t5EzQMV',
              balance: 4.34001,
              token: 'ETH',
            },
            {
              application: { name: 'АБВ-123456-789', id: '1' },
              expiredData: '2025-10-12',
              walletAddress: 'RJgH1Cey379sTCe2WDYsois3nm9z5dMUwtGY8t5EzQMV',
              balance: 4.00001,
              token: 'ETH',
            },
          ]}
        />

        <OperationsHistory />
      </div>
    </div>
  );
};
